import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeInWhenVisible, SectionHeader } from './SectionWrapper';
import { EXPERIENCE } from '../data/portfolio';

function ExpItem({ exp, isDark, index }) {
  const [expanded, setExpanded] = useState(index === 0);

  return (
    <FadeInWhenVisible delay={index * 0.12}>
      <div className="relative pl-10 pb-12 last:pb-0">

        {/* Timeline dot */}
        <div
          className="absolute left-0 top-2 w-3 h-3 rounded-full z-10"
          style={{
            background: 'var(--gold)',
            boxShadow: '0 0 0 4px rgba(232,184,75,0.2)',
          }}
        />

        {/* Card */}
        <motion.div
          whileHover={{ x: 3 }}
          className={`rounded-xl border p-6 cursor-pointer space-y-4 transition ${
            isDark
              ? 'bg-navy-600 border-navy-300/50 hover:border-navy-300'
              : 'bg-white border-gray-200 hover:border-gray-300 shadow-sm'
          }`}
          onClick={() => setExpanded((e) => !e)}
        >

          {/* HEADER */}
          <div className="flex justify-between items-start">

            {/* LEFT */}
            <div className="space-y-1">

              {/* Role */}
              <h3
                style={{
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 500,
                  fontSize: '1.1rem',
                  color: isDark ? 'white' : '#111827',
                }}
              >
                {exp.role}
              </h3>

              {/* Company */}
              <p
                style={{
                  color: 'var(--gold)',
                  fontWeight: 600,
                  fontSize: '0.95rem',
                  fontFamily: "'Inter', sans-serif",
                }}
              >
                {exp.company}
              </p>

              {/* Meta */}
              <p
                style={{
                  fontSize: '0.8rem',
                  color: isDark ? '#6b7280' : '#9ca3af',
                  fontFamily: "'Inter', sans-serif",
                }}
              >
                {exp.period} · {exp.location} · {exp.type}
              </p>

            </div>

            {/* Toggle */}
            <div
              className="text-xs"
              style={{
                fontFamily: "'Inter', sans-serif",
                color: isDark ? '#6b7280' : '#9ca3af',
              }}
            >
              {expanded ? 'Hide' : 'Details'}
            </div>

          </div>

          {/* Summary */}
          <p
            className="text-sm leading-relaxed"
            style={{
              fontFamily: "'Inter', sans-serif",
              color: isDark ? '#9ca3af' : '#6b7280',
            }}
          >
            {exp.summary}
          </p>

          {/* Expanded */}
          <AnimatePresence>
            {expanded && (
              <motion.div
                initial={{ opacity: 0, y: 6 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
                className="pt-4 border-t"
                style={{
                  borderColor: isDark ? 'rgba(255,255,255,0.08)' : '#e5e7eb',
                }}
              >

                {/* Label */}
                <p
                  style={{
                    fontSize: '0.75rem',
                    letterSpacing: '0.08em',
                    color: isDark ? '#6b7280' : '#9ca3af',
                    fontFamily: "'Inter', sans-serif",
                    marginBottom: '10px',
                  }}
                >
                  Key Contributions
                </p>

                {/* List */}
                <ul className="space-y-2">
                  {exp.achievements.map((ach, i) => (
                    <li
                      key={i}
                      className="text-sm flex gap-2"
                      style={{
                        fontFamily: "'Inter', sans-serif",
                        color: isDark ? '#d1d5db' : '#374151',
                      }}
                    >
                      <span style={{ color: 'var(--gold)' }}>•</span>
                      {ach}
                    </li>
                  ))}
                </ul>

              </motion.div>
            )}
          </AnimatePresence>

        </motion.div>
      </div>
    </FadeInWhenVisible>
  );
}

export default function Experience({ isDark }) {
  return (
    <section
      id="experience"
      className={`py-24 ${isDark ? 'bg-navy-900' : 'bg-white'}`}
    >
      <div className="max-w-5xl mx-auto px-6">

        <SectionHeader
          tag="// experience"
          heading="Professional Experience"
          isDark={isDark}
        />

        <div className="mt-12 relative">

          {/* Vertical line */}
          <div
            className="absolute left-[5px] top-0 bottom-0 w-px"
            style={{ background: 'rgba(232,184,75,0.3)' }}
          />

          {EXPERIENCE.map((exp, i) => (
            <ExpItem key={exp.company} exp={exp} isDark={isDark} index={i} />
          ))}

        </div>

      </div>
    </section>
  );
}